module.exports = __webpack_public_path__ + "static/media/rubber3_seamless.ff25e9e0.png";